import { client } from "venuescanner-js/services/socketClient";
import { auth } from "venuescanner-js/services/auth/control";
import schema from "venuescanner-js/schemas/inboxSchema.json";
// import test from './test'
import call from "./call";
import venues from "./venues";
import counts from "./counts";
import leads from "./leads";
import threads from "./threads";
import thread from "./thread";
// import template from './template'
// import folder from './folder'
// import models from './models'
import Emitter from "./models/eventEmitter";
import consume from "./models/consume";
import { onStore, storedIds } from "./models/store";
const modelsNames = Object.keys(schema);
const states = {
  joined: false,
  initiated: false,
  loaded: {},
  objects: {},
  filter: {},
};
modelsNames.forEach((model) => {
  // console.log(`Registered model ${model}`)
  states.loaded[model] = [];
  states.objects[model] = {};
});
// console.log(models)
/** @module
 * @name inboxService
 * @desc Service class for fetching the Users accessible Published Venues
 */
const inboxService = {
  listeners: {},
  newListeners: {},
  forReact: true,
  listenerForNewPushedModels: {},
  listenerForUpdatedPushedModels: {},
  onJoined: [],
  init: (onJoined = () => {}, reConnected = () => {}) => {
    if (states.joined) return onJoined();
    inboxService.onJoined.push(onJoined);
    inboxService.reConnected = reConnected;
    if (states.initiated) return;
    states.initiated = true;
    client.clearListeners();
    client.onReconnect(async () => {
      // console.log('reConnected')
      await reConnected();
      setTimeout(() => {
        inboxService.set.loaded(storedIds());
      });
    });
    auth.mustBeLoggedIn(() => {
      client.init("inbox", () => {
        // console.log('Joined')
        states.joined = true;
        while (inboxService.onJoined.length) {
          const joined = inboxService.onJoined.shift();
          joined();
        }

        modelsNames.forEach((model) => {
          inboxService.listeners[model] = (data) => {
            // console.log(data)
            let built = consume(model, data);
            built = built instanceof Array ? built : [built];
            // console.log(built)
            const areNew = built.filter((m) => m.isNew);
            if (
              areNew &&
              areNew.length &&
              inboxService.listenerForNewPushedModels[model]
            ) {
              // console.log({ areNew })
              inboxService.listenerForNewPushedModels[model](areNew);
            }
            if (
              built &&
              built.length &&
              inboxService.listenerForUpdatedPushedModels[model]
            ) {
              inboxService.listenerForUpdatedPushedModels[model](built);
            }
          };
          // inboxService.newListeners[model] = (data) => {
          //   console.log(data)
          //   consume(model, data)
          // }
        });
        modelsNames.forEach((model) => {
          client.addUpdateListener(model, (data) => {
            // listening for pushed updates (may be a new model instance)
            // console.log({ model, data })
            inboxService.listeners[model](data[model]);
            // console.log(inboxService.listeners[model])
          });

          // client.addNewListener(model, data => {
          //   // console.log({ data })
          //   inboxService.newListeners[model](data[model])
          // })
        });
        // client.addListener('thread', (...args) => {inboxService.listeners.thread(...args)})
        // client.addListener('ATI', (...args) => {inboxService.listeners.ati(...args)})
        // client.addListener('event', (...args) => {inboxService.listeners.event(...args)})
        // // client.addListener('threadPreviews', console.log)
        // client.addListener('threadPreviews', (...args) => {inboxService.listeners.threadPreview(...args)})
        // console.log(models)
      });
    });
  },
  set: {
    timeout: null,
    loaded: ({
      call = [],
      thread = [],
      lead = [],
      admin_thread_info = [],
      admin_event = [],
      thread_preview = [],
      venue = [],
    }) => {
      if (inboxService.set.timeout) clearTimeout(inboxService.set.timeout);
      inboxService.set.timeout = setTimeout(() => {
        client.send("loaded", {
          call,
          thread,
          lead,
          admin_thread_info,
          admin_event,
          thread_preview,
          venue,
        });
        inboxService.set.timeout = null;
      }, 200);
    },
  },
};

onStore(() => {
  // console.log('onStore')
  inboxService.set.loaded(storedIds());
});
inboxService.thread = thread({ inboxService, states });
inboxService.leads = leads({ inboxService, states });
// inboxService.folder = folder({ inboxService, states })
// inboxService.template = template({ inboxService, states })
inboxService.threads = threads({ inboxService, states });
inboxService.venues = venues({ inboxService, states });
inboxService.counts = counts({ inboxService, states });
// inboxService.test = test({ inboxService, states })
inboxService.call = call({ inboxService, states });
inboxService.Emitter = Emitter;

window.inboxService = inboxService;
export default inboxService;
